import {
	ADMINCURRENCYCODE_SUCCESS,
	ADMINCURRENCYCODE_FAILED,
	RESET_ADMINCURRENCYCODE,
	LOADING_ADMINCURRENCYCODE,
	NETWORK_ERROR_ADMINCURRENCYCODE
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINCURRENCYCODE:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINCURRENCYCODE_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINCURRENCYCODE_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINCURRENCYCODE:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINCURRENCYCODE:
			return (state = initialState);
		default:
			return state;
	}
};
